module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "newyrk"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("If There Is I Haven’t Found It Yet")]), _vm._v(" had its U.S. premiere in New York City on September 20, 2012, at the Laura Pels Theatre of the Harold and Miriam Steinberg Center for Theatre.")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Cast")])]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("GEORGE")]), _vm._v(" Brían F. O’Byrne")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("FIONA")]), _vm._v(" Michelle Gomez")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ANNA")]), _vm._v(" Annie Funke")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TERRY")]), _vm._v(" Jake Gyllenhaal")]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Creative Team")])]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("DIRECTOR")]), _vm._v(" Michael Longhurst")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("SETS")]), _vm._v(" Beowulf Boritt")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COSTUMES")]), _vm._v(" Susan Hilferty")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LIGHTS")]), _vm._v(" Natasha Katz")]), _vm._v(" "), _c('p', {
    staticClass: "schar"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ORIGINAL MUSIC AND SOUND")]), _vm._v(" Obadiah Eaves")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f30c4a86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/new-yrk-prod.vue
// module id = 75
// module chunks = 0